import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HOURS_IN_DAY } from '@repo/date-time';
import HourLinesSvg from './HourLinesSvg';
const PIXELS_PER_HOUR = 72;
/**
 * This is to be used with InertiaSlider for picking a time of day (00:00–24:00).
 *
 * Ratio for this scale is 72/60 (72 pixels is 60 minutes).
 */
export default function DayScale() {
    const labelCount = HOURS_IN_DAY + 1;
    return (_jsx("div", { className: "flex h-full items-center", children: Array.from({ length: labelCount }, (_, hourIndex) => {
            const isLast = hourIndex === HOURS_IN_DAY;
            const hLength = isLast ? 0 : PIXELS_PER_HOUR;
            const label = `${String(hourIndex).padStart(2, '0')}:00`;
            return (_jsxs("div", { className: "mt-4 flex flex-col items-start", children: [_jsx("div", { className: "border-l-heading h-6 overflow-hidden border-l-2 pt-2 pl-1", style: { width: `${hLength}px` }, children: _jsx(HourLinesSvg, { color: "text-fg-disabled" }) }), _jsx("div", { className: "text-body mt-1 -translate-x-1/2 text-xs", children: label })] }, hourIndex));
        }) }));
}
